import { fg } from '@atlassian/jira-feature-gating';
import type { ExpandableRowConfig, RowConfig } from './types.tsx';

export const isRowExpandable = (rowConfig: RowConfig): rowConfig is ExpandableRowConfig =>
	rowConfig &&
	'expandable' in rowConfig &&
	rowConfig.expandable === true &&
	fg('treegrid_keyboard_expand');

export const isRowExpanded = (rowConfig: RowConfig): rowConfig is ExpandableRowConfig =>
	isRowExpandable(rowConfig) && rowConfig.expanded === true;
